import React, { PureComponent } from 'react';
import { Segment } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { throttle as _throttle } from 'lodash';
import { func, shape, arrayOf, bool } from 'prop-types';
import { Waypoint } from 'react-waypoint';
import * as Actions from 'Redux/modules/webChat/actions';
import { getMessageByPrivateConsult } from 'Selectors/webChat/messages';

import MessageList from './MessageList/MessageList';
import Uploading from './Uploading/Uploading';

const sortComparator = (item1, item2) => {
  if (item1.sentAt > item2.sentAt) return 1;
  if (item1.sentAt < item2.sentAt) return -1;
  return 0;
};

class MessageBodyDoctor extends PureComponent {
  offset = 0;

  constructor(props) {
    super(props);
    this.handleScroll = _throttle(this.handleScroll, 100);
  }

  componentDidMount() {
    const { isMinimize, conversationActive } = this.props;
    const groupId = conversationActive?.id;
    document
      .getElementById(isMinimize ? `message_body_doctor_${groupId}` : 'message_body_doctor')
      ?.addEventListener('scroll', this.handleScroll);
  }

  componentDidUpdate(prevProps) {
    const { messages, isMinimize, conversationActive, active } = this.props;
    const groupId = conversationActive?.id;
    const { status } = messages;
    if (prevProps.messages.status.loadingPrivate === 0 && status.loadingPrivate === 1) {
      const body = document.getElementById(
        isMinimize ? `message_body_doctor_${groupId}` : 'message_body_doctor',
      );
      if (body) {
        body.scrollTop = body.scrollHeight - this.offset;
      }
    }
    if (active) {
      const body = document.getElementById(
        isMinimize ? `message_body_doctor_${groupId}` : 'message_body_doctor',
      );
      if (body) {
        body.scrollTop = body.scrollHeight - this.offset;
      }
    }
  }

  componentWillUnmount() {
    const { isMinimize, conversationActive } = this.props;
    const groupId = conversationActive?.id;
    const body = document.getElementById(
      isMinimize ? `message_body_doctor_${groupId}` : 'message_body_doctor',
    );
    if (body) {
      body.removeEventListener('scroll', this.handleScroll);
    }
  }

  handleScroll = e => {
    const body = e.target;
    const newOffset = body.scrollHeight - body.scrollTop;
    this.offset = newOffset;
  };

  getMoreBackwardMessages = () => {
    const { isMinimize, conversationActive } = this.props;
    const groupId = conversationActive?.id;
    const body = document.getElementById(
      isMinimize ? `message_body_doctor_${groupId}` : 'message_body_doctor',
    );
    const newOffset = body.scrollHeight - body.scrollTop;
    this.offset = newOffset;

    const { getPrivateMessagesBackwardByTime, messages, listMessages } = this.props;
    const {
      status,
      meta: { isLoadMoreBackward },
    } = messages;
    const time = listMessages[0]?.sentAt;
    if (status.loadingBackward !== 0 && isLoadMoreBackward) {
      getPrivateMessagesBackwardByTime({
        timestamp: time,
        conversationId: conversationActive.latestConsult.doctorConversation.id,
        count: 20,
      });
    }
  };

  findOtherDoctor = uuid => {
    const doctors = this.props.conversationActive?.latestConsult?.doctors || [];
    const doctor = doctors.find(_doctor => _doctor.userUuid === uuid);

    return {
      avatarUrl: doctor?.avatarUrl || '',
      fullName: doctor?.fullName || '',
    };
  };

  render() {
    const {
      conversationActive,
      messages,
      listMessages,
      doctor,
      uploadGroup,
      isMinimize,
      onSetReply,
    } = this.props;
    const {
      meta: { isLoadMorePrivate },
      status: { loadingPrivate },
    } = messages;

    const groupId = conversationActive?.id;
    const channelUuid = conversationActive?.latestConsult?.channel?.uuid || null;

    const isLoading =
      loadingPrivate === 0 && listMessages.length === 0 && listMessages.length === 0;
    if (isLoading) {
      this.offset = 0;
      return (
        <Segment
          className="message-body"
          id={isMinimize ? `message_body_doctor_${groupId}` : 'message_body_doctor'}
          loading={isLoading}
          basic
        />
      );
    }

    if (listMessages.length === 0 && loadingPrivate === 1) {
      return (
        <div style={{ textAlign: 'center', marginTop: '1rem' }}>
          <span>
            This conversation was created for doctors only. All information in this chat will not be
            shared to the patient.
          </span>
        </div>
      );
    }

    return (
      <>
        {channelUuid === uploadGroup && <Uploading />}
        <div
          className="message-body message_body_doctor"
          id={isMinimize ? `message_body_doctor_${groupId}` : 'message_body_doctor'}>
          {isLoadMorePrivate && (
            <Waypoint onEnter={this.getMoreBackwardMessages}>
              <div className="text-center">Loading...</div>
            </Waypoint>
          )}
          <MessageList
            conversation={conversationActive}
            list={listMessages}
            messages={messages}
            doctor={doctor}
            findOtherUser={this.findOtherDoctor}
            handleLoadMore={this.getMoreBackwardMessages}
            onSetReply={onSetReply}
          />
        </div>
      </>
    );
  }
}

MessageBodyDoctor.propTypes = {
  conversationActive: shape({}).isRequired,
  messages: shape({}).isRequired,
  doctor: shape({}).isRequired,
  listMessages: arrayOf(shape({})).isRequired,
  getPrivateMessagesBackwardByTime: func.isRequired,
  isMinimize: bool.isRequired,
  active: bool.isRequired,
  onSetReply: func.isRequired,
};

const mapStateToProps = (state, props) => ({
  listMessages: getMessageByPrivateConsult(
    state,
    props.conversationActive?.latestConsult?.doctorConversation?.id,
  ).sort(sortComparator),
  messages: state.webChat.messages,
  consults: state.webChat.consults,
  uploadGroup: state.webChat.commons.uploadGroup,
});

const mapDispatchToProps = {
  getPrivateMessagesBackwardByTime: Actions.getPrivateMessagesBackwardByTime,
};

export default connect(mapStateToProps, mapDispatchToProps)(MessageBodyDoctor);
